var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"container"},[_c('h1',[_vm._v("Session expired")]),_vm._v(" "),_c('p',[_vm._v("\n    Please, do "),_c('router-link',{attrs:{"to":"/login"}},[_vm._v("login")]),_vm._v(" again to continue..\n  ")],1)])}
var staticRenderFns = []
export { render, staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-07467bbe","hasScoped":false,"optionsId":"0","buble":{"transforms":{}}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/SessionExpired.vue
// module id = joD8
// module chunks = 1